import React, { useState } from 'react';
import axios from 'axios';
import { Star, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { SimpleModal, errorText } from './SimpleModal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getActorToken = () => localStorage.getItem('subscriberToken') || localStorage.getItem('token');

const StarPicker = ({ value, onChange }) => {
  const [hover, setHover] = useState(0);
  return (
    <div style={{ display: 'flex', gap: 6, justifyContent: 'center', margin: '0.5rem 0 1rem' }} onMouseLeave={() => setHover(0)}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)} onMouseEnter={() => setHover(n)} data-testid={`review-star-${n}`}
          aria-label={`${n} estrela${n > 1 ? 's' : ''}`} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, transition: 'transform 0.15s' }}>
          <Star className="w-9 h-9" style={{ color: '#f5b301', fill: n <= (hover || value) ? '#f5b301' : 'transparent' }} />
        </button>
      ))}
    </div>
  );
};

export const PlatformReviewModal = ({ onClose, onLogin, primaryColor = '#68AAB0' }) => {
  const token = getActorToken();
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [state, setState] = useState({ saving: false, error: '', done: '' });

  const submit = async () => {
    if (!rating) return setState({ ...state, error: 'Escolha de 1 a 5 estrelas' });
    setState({ saving: true, error: '', done: '' });
    try {
      const { data } = await axios.post(`${API}/platform/reviews`, { rating, comment }, { headers: { Authorization: `Bearer ${token}` } });
      setState({ saving: false, error: '', done: data.message });
    } catch (err) {
      setState({ saving: false, error: errorText(err, 'Não foi possível enviar a avaliação'), done: '' });
    }
  };

  return (
    <SimpleModal title="Avalie a plataforma Livrum" onClose={onClose} testId="review-modal">
      {!token ? (
        <div data-testid="review-login-required" style={{ textAlign: 'center' }}>
          <p style={{ color: '#4a5568', marginBottom: '1rem' }}>Para avaliar a plataforma, faça login como leitor ou editor.</p>
          <Button onClick={onLogin} style={{ background: primaryColor }} data-testid="review-login-btn">Entrar</Button>
        </div>
      ) : state.done ? (
        <p data-testid="review-success" style={{ textAlign: 'center', color: '#276749', fontWeight: 600, padding: '1rem 0' }}>{state.done}</p>
      ) : (
        <>
          <p style={{ color: '#4a5568', textAlign: 'center', fontSize: '0.9rem' }}>Como está sendo sua experiência?</p>
          <StarPicker value={rating} onChange={(n) => { setRating(n); setState((s) => ({ ...s, error: '' })); }} />
          <textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={2000} rows={4} placeholder="Deixe um comentário (opcional)"
            data-testid="review-comment-input" style={{ width: '100%', border: '1px solid #e2e8f0', borderRadius: 8, padding: '0.75rem', fontSize: '0.9rem', resize: 'vertical' }} />
          {state.error && <p data-testid="review-error" style={{ color: '#c53030', fontSize: '0.85rem', marginTop: '0.5rem' }}>{state.error}</p>}
          <Button onClick={submit} disabled={state.saving} style={{ width: '100%', marginTop: '1rem', background: primaryColor }} data-testid="review-submit-btn">
            {state.saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Enviar avaliação'}
          </Button>
        </>
      )}
    </SimpleModal>
  );
};
